// Backend de Carwash: recibe el formulario de cotización y el flujo de /promo-scan.
export const API_BASE = (process.env.REACT_APP_API_URL || "https://bakend.tecnologia-er.com/carwash").trim();

export const PHONE_DISPLAY = "+1 (512) 748-8298";
export const PHONE_TEL = "tel:+15127488298";
